var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.2553 14.9816C25.5736 12.2738 21.6082 8 15.8275 8C10.047 8 6.08149 12.2738 4.39965 14.9816C3.8668 15.8395 3.86676 16.9177 4.39968 17.7757C6.08141 20.483 10.0468 24.7555 15.8273 24.7555C21.6079 24.7555 25.5733 20.4829 27.2551 17.7757C27.7881 16.9178 27.7882 15.8396 27.2553 14.9816ZM15.8275 10C20.5832 10 24.0197 13.5626 25.5563 16.0368C25.6878 16.2485 25.6878 16.5086 25.5563 16.7203C24.0196 19.1938 20.5831 22.7555 15.8273 22.7555C11.0716 22.7555 7.6351 19.1939 6.09861 16.7204C5.96714 16.5087 5.96712 16.2485 6.09862 16.0368C7.63541 13.5625 11.072 10 15.8275 10Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8278 19.3782C17.4847 19.3782 18.8278 18.035 18.8278 16.3782C18.8278 14.7213 17.4847 13.3782 15.8278 13.3782C14.1709 13.3782 12.8278 14.7213 12.8278 16.3782C12.8278 18.035 14.1709 19.3782 15.8278 19.3782ZM15.8278 21.3782C18.5892 21.3782 20.8278 19.1396 20.8278 16.3782C20.8278 13.6168 18.5892 11.3782 15.8278 11.3782C13.0664 11.3782 10.8278 13.6168 10.8278 16.3782C10.8278 19.1396 13.0664 21.3782 15.8278 21.3782Z",
    fill: "#F59D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.c26d239f6e5af630d19b3876fc0fda91.svg";
export { ForwardRef as ReactComponent };